<script>
	// Standard dollar display. Tax is applied only when GST is charged for this practitioner
	// (NZ always; AU only when not gst_approved).
	import { formatDollars } from '$lib/currency.js';
	import { gstRate } from '$state/country.js';
	import { profile } from '$state/profile.svelte.js';

	/** @type {{ amount: number | string | number[], label?: import('$lib/currency.js').DollarLabel, addTax?: boolean, removeTax?: boolean, calcTax?: boolean }} */
	let { amount, label = 'inc', addTax = false, removeTax = false, calcTax = false } = $props();

	const output = $derived(
		formatDollars(amount, {
			label,
			addTax,
			removeTax,
			calcTax,
			chargeGst: profile.chargeGst,
			gstRate
		})
	);
</script>

{output}
